import { CompositeSessionInfoSelectors } from '~selectors/SessionInfoSelectors';

import { AppState } from '../../../../app/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { removeFromThisCollectionAction } from '../../../../Collections/actions/RemoveFromThisCollectionAction';
import { ICollectionInfo } from '../../../../Collections/space/ICollectionInfo';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../models/IContentInfo';
import { selectSpaceInfoItem } from '../../../selectors/SpaceInfoSelectors';
import { isSingleCollectionSpace } from '../../../state/SpaceInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RemoveFromThisCollectionAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.RemoveFromThisCollection,
  translateName: Messages.removeFromThisCollection,
  isVisible: (targetItems: IContentInfo[], state: AppState) => {
    return FeatureFlags.collectionsEnabled && isSingleCollectionSpace(state.spaceInfo);
  },
  isClickable: (_availableActions: {}, targetItems: IContentInfo[], state: AppState) => {
    const collection = <ICollectionInfo> selectSpaceInfoItem(state);
    return CompositeSessionInfoSelectors.currentUserIsAdminOrOwnerSelector(collection.owner)(state);
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    return removeFromThisCollectionAction(targetItems);
  }
};
